var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 2.2H11.8C12.24 2.2 12.6 2.56 12.6 3V9.1C12.6 9.54 12.24 9.9 11.8 9.9H7.4L4.2 12.4V9.9H2.2C1.76 9.9 1.4 9.54 1.4 9.1V3C1.4 2.56 1.76 2.2 2.2 2.2Z",
    stroke: "#9AA88A",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComment);
export default __webpack_public_path__ + "static/media/ic-comment.dfcb392aa94fa58a6dd1a8934968f714.svg";
export { ForwardRef as ReactComponent };